import React from 'react';
import { Page } from '../components/Page';
import { PageHeader } from '../components/PageHeader';

export const Lectures = () => {
  return (
    <Page>
      <PageHeader title="Fyrirlestrar" />
    </Page>
  );
};
